<template>
  <v-form ref="form" v-model="valid">
    <v-card>
      <v-card-title>휴가 등록 및 확정</v-card-title>
      <v-card-text>
        <v-container>
          <v-select
            v-model="data.empNo"
            :items="empLists"
            item-text="empNm"
            item-value="empNo"
            :rules="[rules.required]"
            label="대상자"
          ></v-select>
          <v-row>
            <v-col>
              <v-menu
                ref="openStDt"
                v-model="openStDt"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="data.startDt"
                    :rules="[rules.required]"
                    label="시작일"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="data.startDt"
                  no-title
                  scrollable
                  @input="saveStDt"
                >
                  <!-- <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="openStDt = false"
                    >취소</v-btn
                  >
                  <v-btn text color="primary" @click="saveStDt">저장</v-btn> -->
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-text-field
                label
                v-model="data.startTm"
                :rules="[rules.required]"
                type="time"
                prepend-icon="mdi-alarm"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-menu
                ref="openEdDt"
                v-model="openEdDt"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="data.endDt"
                    :rules="[rules.required, rules.diffTime]"
                    label="종료일"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="data.endDt"
                  :min="data.startDt"
                  no-title
                  scrollable
                  @input="openEdDt = false"
                  @change="dateValidate"
                >
                  <!-- <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="openEdDt = false"
                    >취소</v-btn
                  >
                  <v-btn text color="primary" @click="saveEdDt">저장</v-btn> -->
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-text-field
                label
                v-model="data.endTm"
                :rules="[rules.required, rules.diffTime]"
                type="time"
                prepend-icon="mdi-alarm"
                @change="dateValidate"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-textarea
            v-model="data.planText"
            name="input-7-1"
            label="비고"
          ></v-textarea>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="onCancel">취소</v-btn>
        <v-btn color="green darken-1" text @click="onSubmit">저장</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      valid: true,
      openStDt: false,
      openEdDt: false,
      data: {
        empNo: "",
        startDt: moment().format("YYYY-MM-DD"),
        startTm: "10:00",
        endDt: moment().format("YYYY-MM-DD"),
        endTm: "19:00",
        planText: null,
      },
      rules: {
        required: value => !!value || "필수 항목입니다.",
        diffTime: true,
      },
    };
  },
  computed: {
    // today() {
    //   return moment().format("YYYY-MM-DD");
    // },
  },
  props: ["isShow", "empLists"],
  watch: {
    isShow(newVal) {
      if (!newVal) {
        this.reset();
      }
    },
  },
  mounted() {
    this.reset();
  },
  methods: {
    saveStDt() {
      // 시작일이 종료일보다 늦을 때 종료일 재설정
      const { startDt, endDt } = this.data;
      const end = moment(endDt);
      const start = moment(startDt);
      const diff = moment.duration(end.diff(start)).asDays();

      // this.$refs.openStDt.save(startDt);

      if (diff < 0) {
        this.data.endDt = startDt;
      }

      this.openStDt = false;
    },
    dateValidate() {
      // 종료일 validate
      const { startDt, endDt, startTm, endTm } = this.data;

      const startDiff = moment(`${startDt} ${startTm}`);
      const endDiff = moment(`${endDt} ${endTm}`);
      const diffTime = endDiff.diff(startDiff, "minutes");

      this.rules.diffTime =
        diffTime > 0 || "종료일이 시작일보다 먼저일 수 없습니다.";
    },
    reset() {
      this.$refs.form.resetValidation();
      Object.assign(this.$data, this.$options.data());
    },
    onCancel() {
      this.reset();
      this.$emit("hideModal");
    },
    onSubmit() {
      this.$refs.form.validate();
      if (!this.valid) return false;

      const { empNo, planText, startDt, startTm, endDt, endTm } = this.data;
      const planStDt = moment(startDt).format("YYYYMMDD");
      const planStTm = startTm.replace(":", "");
      const planEdDt = moment(endDt).format("YYYYMMDD");
      const planEdTm = endTm.replace(":", "");

      const newData = {
        empList: [{ empNo: empNo }],
        planText,
        planStDt,
        planStTm,
        planEdDt,
        planEdTm,
      };

      this.$emit("registerVacation", newData);
    },
  },
};
</script>

<style></style>
